import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Utilities } from 'src/app/services/utilities';

import { AppStateModel } from '../../+redux/redux.models';
import { MemberSessionService } from '../../member/member-session.service';
import { IMemberStateModel } from '../../member/member.models';
import { TelephonyFormattedQueryParams } from '../../telephony/telephony-queryparams.state.models';


@Injectable({
    providedIn: 'root'
})
export class SystemEvaluatorService {
    internalEvaluator = new SystemEvaluatorInternalService();

    get user() {
        return {
            role: this.store.selectSnapshot<string>((state: AppStateModel) => state.roleState.currentRoleName)
        }
    }

    get member() {
        const memberState = this.store.selectSnapshot<IMemberStateModel>((state: AppStateModel) => state.memberState);
        return {
            id: memberState.currentSession.memberId,
            base64: memberState.currentSession.base64,
            tenant: {
                id: memberState.currentSession.tenantId,
            },
            oncall: memberState.currentSession.memberContext?.metadata.onCall,
            verified: memberState.currentSession.memberContext?.metadata.verified,
            greetingTaskCompleted: memberState.currentSession.memberContext?.metadata.greetingTaskCompleted ?? false,
            sessionStatus: this.store.selectSnapshot<string>((state: AppStateModel) => state.memberState.currentSession.memberContext && state.memberState.currentSession.memberContext.metadata.sessionStatus)
        }
    }

    get screener() {
        const telephonyParams = this.store.selectSnapshot<TelephonyFormattedQueryParams>((state: AppStateModel) => state.telephonyQueryParamsState && state.telephonyQueryParamsState.formattedQueryParams);
        //#region no params
        const noScreenerParams = !!telephonyParams && Utilities.allPropertiesAreUnset(telephonyParams);
        //#endregion
        //#region pending params
        const pendingParams = !!telephonyParams && ((telephonyParams.direction === 'OUTBOUND' && telephonyParams.reasonId != null) || (telephonyParams.direction == 'INBOUND' && telephonyParams.originId != null));
        //#endregion

        let status: string;
        switch (true) {
            case noScreenerParams:
                status = 'empty';
                break;
            case pendingParams:
                status = 'partial';
                break;
            default:
                status = 'full';
        }

        const memberState = this.store.selectSnapshot<IMemberStateModel>((state: AppStateModel) => state.memberState)
        const { context } = MemberSessionService.getContextByMemberGroupHash(memberState.sessionsTracker.contexts, memberState.currentSession.memberContext.member.$memberHash);

        return {
            status,
            directionvalue: telephonyParams?.directionValue,
            direction: telephonyParams?.direction,
            inputorigin: telephonyParams?.origin,
            inputreason: telephonyParams?.reason,
            originid: context?.originId,
            origin: context?.origin,
            reasonid: context?.reasonId,
            reason: context?.reason,
        }
    }

    get iteration() {
        return {
            'member-note': {
                added: false
            },
            'facilityrequest-note': {
                added: false
            }
        }
    }

    constructor(private store: Store) { }


    evaluate<T extends any = any>(expression: string): T {
        if (expression) {
            const formatted = expression.replace(/system\./g, 'this.');
            return this.internalEvaluator.runExpression.call(this, formatted) as T;
        }
        return true as unknown as T;
    }
}


class SystemEvaluatorInternalService {
    runExpression(expression: any) {
        try {
            return eval(expression);
        } catch (err) {
            return true;
        }
    }
}
